import NoMatchScreen from './NoMatchScreen';

export default NoMatchScreen;
